module.exports = "img/info-slide-4.17ad6a.jpeg";